import { Component, h, Prop, State, Watch } from '@stencil/core';
import { SpaceImage } from '@artask/tambr-models/models/spaces.model';


@Component({
  tag: 'tambr-space-images',
  styleUrl: 'tambr-space-images.css',
  shadow: true
})
export class TambrSpaceImages {

  @Prop() images: SpaceImage[] = [];
  @Prop() type: 'card' | 'dialog' = 'card';

  @State() isPrevSlideAvailable: boolean = false;
  @State() isNextSlideAvailable: boolean = false;
  @State() currentSlide: number = 0;

  @Watch('images') imagesChanged( newValue: SpaceImage[], oldValue: SpaceImage[] ) {
    console.log( 'images changed:', newValue, oldValue );
    this.updateButtonVisibility();
  }

  sliderWrapper: HTMLElement;

  nextSlide() {
    this.sliderWrapper.scrollLeft += this.sliderWrapper.clientWidth;
  }

  prevSlide() {
    this.sliderWrapper.scrollLeft -= this.sliderWrapper.clientWidth;
  }

  componentDidLoad() {
    this.sliderWrapper.addEventListener( 'scroll', () => this.changeSlide() );
    window.addEventListener( 'resize', () => this.updateButtonVisibility() );
  }

  componentWillLoad() {
    this.updateButtonVisibility();
  }

  changeSlide() {
    this.currentSlide = Math.round( this.sliderWrapper.scrollLeft / this.sliderWrapper.clientWidth );
    this.updateButtonVisibility();
  }

  updateButtonVisibility() {
    this.isPrevSlideAvailable = this.currentSlide > 0;
    this.isNextSlideAvailable = this.currentSlide < this.images.length - 1;
  }

  disconnectedCallback() {
    this.sliderWrapper.removeEventListener( 'scroll', () => this.changeSlide() );
    window.removeEventListener( 'resize', () => this.updateButtonVisibility() );
  }

  render() {
    return (
      <div class="tambr-slider">
        <div class={ "tambr-slider-wrapper " + this.type } ref={ ref => this.sliderWrapper = ref }>
          { this.images.map( image => (
            <img class="tambr-slider-item" src={ image.medium } />
          ))}
        </div>

        { this.renderPrevSlideButton() }
        { this.renderNextSlideButton() }
      </div>
    );
  }

  renderPrevSlideButton() {
    return (
      <button id="prev-button" 
        class={"tambr-arrow-button " + ( this.isPrevSlideAvailable ? 'visible' : 'hidden' ) } 
        onClick={ () => this.prevSlide() }>
          <tambr-icon type="left-arrow" class="arrow"></tambr-icon>
      </button>
    )
  }

  renderNextSlideButton() {
    return (
      <button id="next-button" 
        class={"tambr-arrow-button " + (this.isNextSlideAvailable ? 'visible' : 'hidden') } 
        onClick={ () => this.nextSlide() }>
          <tambr-icon type="right-arrow" class="arrow"></tambr-icon>
      </button>
    )
  }
}
